function Status() {
  return <>Die Aufnahme für diesen SP wurde abgeschlossen.</>;
}

export default Status;
